import { createRouter, createWebHistory } from 'vue-router'
import createStore from '@/store'

const initiate = () => import('@/views/initiate/')
const initiate_login = () => import('@/views/initiate/login/')
const initiate_forgot = () => import('@/views/initiate/forgot/')
const initiate_forgot_sendToken = () => import('@/views/initiate/forgot/SendToken')
const initiate_forgot_sendValidationCode = () => import('@/views/initiate/forgot/SendValidationCode')
const initiate_forgot_changePassword = () => import('@/views/initiate/forgot/ChangePassword')
const initiate_forgot_sucessForgot = () => import('@/views/initiate/forgot/SuccessForgot')
const initiate_register = () => import('@/views/initiate/register/')
const initiate_short_register = () => import('@/views/initiate/shortRegister')
const payment = () => import('@/views/payment/index')
const shortCheckout = () => import('@/views/shortCheckout/index')
const card_update = () => import('@/views/app/account/CardUpdate')
const payment_ticket_order = () => import('@/views/payment/ticketOrder')

const app = () => import('@/views/app/')
const app_home = () => import('@/views/app/home/')

const app_categories = () => import('@/views/app/categories/')
const app_categories_backstaage = () => import('@/views/app/categories/BackStaage')
const app_categories_staageclass = () => import('@/views/app/categories/StaageClass')
const app_categories_napratica = () => import('@/views/app/categories/NaPratica')
const app_categories_staagedocs = () => import('@/views/app/categories/StaageDocs')
const app_categories_details = () => import('@/views/app/categories/Details')
const app_categories_theme = () => import('@/views/app/categories/Theme')
const app_categories_professions = () => import('@/views/app/categories/Professions')
const app_categories_paths = () => import('@/views/app/categories/Paths')
const app_categories_path_details = () => import('@/views/app/categories/PathDetails')
const app_categories_mentorship_details = () => import('@/views/app/categories/MentorshipDetails')
const app_categories_formation_details = () => import('@/views/app/categories/FormationsDetails')
const app_categories_profession_details = () => import('@/views/app/categories/ProfessionDetails')

const app_account = () => import('@/views/app/account/')
const app_account_me = () => import('@/views/app/account/Me')
const app_account_staager = () => import('@/views/app/account/Staager')
const app_account_achievements = () => import('@/views/app/account/Achievements')
const app_account_certificate = () => import('@/views/app/account/Certificate')
const app_account_subscription = () => import('@/views/app/account/Subscription')
const app_account_password = () => import('@/views/app/account/Password')
const app_account_staageJobs = () => import('../views/app/account/StaageJobs')
const app_account_view_certificate = () => import('@/views/app/account/ViewCertificate')

const app_suitability = () => import('@/views/suitability')

const app_favorites = () => import('@/views/app/favorites/')
const app_search = () => import('@/views/app/search')
const app_authorize_device = () => import('@/views/initiate/device')
const app_progress = () => import('@/views/app/progress/')
const app_quiz = () => import('@/views/app/quiz/')
const app_staageTools = () => import('@/views/app/staageTools')
const app_mentors = () => import('@/views/app/Mentors')

const app_infinity = () => import('@/views/app/infinity')
const app_infinity_typ = () => import('@/views/app/infinity/ThankYouPage')
const app_infinity_ticket = () => import('@/views/app/infinity/ticketOrder')

const Level = () => import('@/components/Level')
const PlayerVideoJS = () => import('@/components/PlayerVideoJS')
const NotFound = () => import('@/views/notFound')
const support = () => import('@/views/support/')
const support_termsOfUse = () => import('@/views/support/termsOfUse')
const support_privacyPolicy = () => import('@/views/support/privacyPolicy')
const support_help = () => import('@/views/support/help')

const staagejobs = () => import('@/views/marketplace/index')
const staagejobs_home = () => import('@/views/marketplace/Home')
const staagejobs_profiles = () => import('@/views/marketplace/Profiles')

const routes = [
  {
    path: '/',
    name: 'application',
    meta: { requiresAuth: true },
    redirect: function () {
      return { name: 'app.home' }
    }
  },
  {
    path: '/initiate',
    component: initiate,
    name: 'initiate',
    meta: { requiresAuth: false },
    redirect: function () {
      return { name: 'initiate.login' }
    },
    children: [
      {
        path: '/initiate/login',
        name: 'initiate.login',
        component: initiate_login
      },
      {
        path: '/initiate/register/4',
        name: 'initiate.register',
        component: initiate_register
      },
      {
        path: '/initiate/register',
        name: 'initiate.short.register',
        component: initiate_short_register
      },
      {
        path: '/initiate/forgot',
        name: 'initiate.forgot',
        component: initiate_forgot,
        redirect: function (to) {
          const { hash, params, query } = to
          return { name: 'initiate.forgot.sendToken' }
        },
        children: [
          {
            path: '/initiate/forgot/1',
            name: 'initiate.forgot.sendToken',
            component: initiate_forgot_sendToken
          },
          {
            path: '/initiate/forgot/2',
            name: 'initiate.forgot.sendValidationCode',
            component: initiate_forgot_sendValidationCode
          },
          {
            path: '/initiate/forgot/3',
            name: 'initiate.forgot.changePassword',
            component: initiate_forgot_changePassword
          },
          {
            path: '/initiate/forgot/4',
            name: 'initiate.forgot.successForgot',
            component: initiate_forgot_sucessForgot
          }
        ]
      }
    ]
  },
  {
    path: '/shortCheckout',
    name: 'shortCheckout',
    meta: { requiresAuth: false },
    component: shortCheckout,
    children: [
      // {
      //   path: '/shortCheckout/:userID',
      //   name: 'shortCheckout',
      //   component: shortCheckout
      // }
    ]
  },
  {
    path: '/payment/:userID',
    name: 'payment',
    meta: { requiresAuth: false },
    component: payment,
    children: []
  },
  {
    path: '/payment/:userID/ticketorder',
    name: 'payment.ticketorder',
    meta: { requiresAuth: false },
    component: payment_ticket_order
  },
  {
    path: '/cardUpdate/:userID',
    component: card_update,
    name: 'card.update'
  },
  {
    path: '/app/',
    component: app,
    name: 'app',
    meta: { requiresAuth: true },
    redirect: function () {
      return { name: 'app.home' }
    },
    children: [
      {
        path: '/app/home',
        name: 'app.home',
        component: app_home
      },
      {
        path: '/app/trail/:trailID',
        name: 'app.trail',
        component: Level
      },
      {
        path: '/app/categories',
        name: 'app.categories',
        component: app_categories,
        children: [
          {
            path: '/app/categories/bastidores',
            component: app_categories_backstaage,
            name: 'app.categories.backstaage'
          },
          {
            path: '/app/categories/staageclass',
            component: app_categories_staageclass,
            name: 'app.categories.staageclass'
          },
          {
            path: '/app/categories/staagedocs',
            component: app_categories_staagedocs,
            name: 'app.categories.staagedocs'
          },
          {
            path: '/app/categories/napratica',
            component: app_categories_napratica,
            name: 'app.categories.napratica'
          },
          {
            path: '/app/categories/theme/:themeID',
            name: 'app.theme',
            component: app_categories_theme
          },
          {
            path: '/app/categories/details/:courseID',
            name: 'app.details',
            component: app_categories_details
          },
          {
            path: '/app/categories/professions',
            name: 'app.categories.professions',
            component: app_categories_professions // Profissões
          },
          {
            path: '/app/categories/paths',
            name: 'app.categories.paths',
            component: app_categories_paths // Trilhas
          },
          {
            path: '/app/categories/profession/:professionID',
            name: 'app.profession.details',
            component: app_categories_profession_details // Detalhes da profissão
          },
          {
            path: '/app/categories/path/:pathID',
            name: 'app.path.details',
            component: app_categories_path_details // Detalhes da trilha
          },
          {
            path: '/app/categories/mentorship/:pathID',
            name: 'app.mentorship.details',
            component: app_categories_mentorship_details // Detalhes da trilha
          },
          {
            path: '/app/categories/formations/:pathID',
            name: 'app.mentorship.formations',
            component: app_categories_formation_details // Detalhes da trilha
          }
        ]
      },
      {
        path: '/app/favorites',
        name: 'app.favorites',
        component: app_favorites
      },
      {
        path: '/app/account',
        name: 'app.account',
        component: app_account,
        children: [
          {
            path: '/app/account/me',
            component: app_account_me,
            name: 'app.account.me'
          },
          {
            path: '/app/account/subscription',
            component: app_account_subscription,
            name: 'app.account.subscription'
          },
          {
            path: '/app/account/staager',
            component: app_account_staager,
            name: 'app.account.staager'
          },
          {
            path: '/app/account/achievements',
            component: app_account_achievements,
            name: 'app.account.achievements'
          },
          {
            path: '/app/account/certificate',
            component: app_account_certificate,
            name: 'app.account.certificate'
          },
          {
            path: '/app/account/password',
            component: app_account_password,
            name: 'app.account.password'
          },
          {
            path: '/app/account/staagejobs',
            component: app_account_staageJobs,
            name: 'app.account.staagejobs'
          }
        ]
      },
      {
        path: '/app/account/certificate/:certificateID',
        component: app_account_view_certificate,
        name: 'app.account.viewcertificate'
      },
      {
        path: '/app/search',
        name: 'app.search',
        component: app_search
      },
      {
        path: '/app/progress',
        name: 'app.progress',
        component: app_progress
      },
      {
        path: '/connect',
        name: 'app.authorize.device',
        component: app_authorize_device
      },
      {
        path: '/app/quiz/:quizID',
        name: 'app.quiz',
        component: app_quiz
      }
      // {
      //   path: '/infinity-checkout',
      //   name: 'infinity.checkout',
      //   component: app_infinity
      // },
      // {
      //   path: '/infinity-ticket',
      //   name: 'infinity.ticket',
      //   component: app_infinity_ticket
      // },
      // {
      //   path: '/infinity-typ',
      //   name: 'infinity.typ',
      //   component: app_infinity_typ
      // }
    ]
  },
  {
    path: '/app/suitability',
    name: 'app.suitability',
    component: app_suitability,
    meta: { requiresAuth: true }
  },
  {
    path: '/freemium',
    component: app,
    name: 'freemium.app',
    meta: { requiresAuth: false },
    redirect: function () {
      return { name: 'freemium.app.home' }
    },
    children: [
      {
        path: '/freemium/app/home',
        name: 'freemium.app.home',
        component: app_home
      },
      {
        path: '/freemium/trail/:trailID',
        name: 'freemium.app.trail',
        component: Level
      },
      {
        path: '/freemium/app/mentors',
        name: 'freemium.app.mentors',
        component: app_mentors
      },
      {
        path: '/freemium/app/categories',
        name: 'freemium.app.categories',
        component: app_categories,
        children: [
          {
            path: '/freemium/app/categories/bastidores',
            component: app_categories_backstaage,
            name: 'freemium.app.categories.backstaage'
          },
          {
            path: '/freemium/app/categories/staageclass',
            component: app_categories_staageclass,
            name: 'freemium.app.categories.staageclass'
          },
          {
            path: '/freemium/app/categories/staagedocs',
            component: app_categories_staagedocs,
            name: 'freemium.app.categories.staagedocs'
          },
          {
            path: '/freemium/app/categories/napratica',
            component: app_categories_napratica,
            name: 'freemium.app.categories.napratica'
          },
          {
            path: '/freemium/app/categories/theme',
            name: 'freemium.app.theme',
            component: app_categories_theme
          },
          {
            path: '/freemium/app/categories/details/:courseID',
            name: 'freemium.app.details',
            component: app_categories_details
          }
        ]
      },
      {
        path: '/freemium/search',
        name: 'freemium.app.search',
        component: app_search
      }
    ]
  },
  {
    path: '/app/watch/:courseId/:lessonId',
    name: 'app.watch',
    component: PlayerVideoJS
  },
  {
    path: '/support/',
    name: 'support',
    component: support,
    redirect: function () {
      return { name: 'support.faq' }
    },
    children: [
      {
        path: '/support/help',
        component: support_help,
        name: 'support.help'
      },
      {
        path: '/support/termsOfUse',
        component: support_termsOfUse,
        name: 'support.termsOfuse'
      },
      {
        path: '/support/privacyPolicy',
        component: support_privacyPolicy,
        name: 'support.privacyPolicy'
      }
    ]
  },
  {
    path: '/staage-tools',
    name: 'app.staageTools',
    component: app_staageTools,
    meta: { requiresAuth: true }
  },
  {
    path: '/app/mentors',
    name: 'app.mentors',
    component: app_mentors
  },
  {
    path: '/staagejobs/',
    name: 'staagejobs',
    component: staagejobs,
    redirect: function () {
      return { name: 'staagejobs.home' }
    },
    children: [
      {
        path: '/staagejobs/home',
        name: 'staagejobs.home',
        component: staagejobs_home
      },
      {
        path: '/staagejobs/profiles',
        component: staagejobs_profiles,
        name: 'staagejobs.profiles'
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
    name: 'notFound'
  },
  {
    path: '/notFound',
    component: NotFound,
    name: 'routeNotFound'
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    window.scrollTo(0, 0)
  }
})

router.beforeEach(async (to, from, next) => {
  const userID = createStore.getters['user/userData'].userID
  if (userID) {
    dataLayer.push({ event: 'virtualPageView', userId: userID, pageUrl: to.fullPath })
  }

  createStore.commit('auth/setShowFullScreen', to.name && to.name === 'app.watch')
  const isLogged = await createStore.dispatch('auth/isLogged')
  let queryParams
  if (
    to.matched.some((record) => record.meta.requiresAuth === true) === false &&
    !Object.keys(to.query).length &&
    Object.keys(from.query).length
  ) {
    queryParams = { ...from.query }
  }

  if (from.path.includes('freemium') && to.matched.some((record) => record.meta.requiresAuth === true)) {
    next({ name: `freemium.${to.name}`, params: to.params, query: { ...from.query } })
  } else {
    if (to.matched.some((record) => record.meta.requiresAuth === true) && isLogged === false) {
      next({ name: 'initiate.login' })
    } else if (to.matched.some((record) => record.meta.requiresAuth === false) && isLogged === true) {
      next({ name: 'app.home' })
    } else if (queryParams) {
      next({ ...to, query: queryParams })
    } else {
      next()
    }
  }
})

export default router
